import { useState } from "react";
import { Link } from "react-router-dom";
import {
  GAMES_GRID,
  TESTIMONIALS,
  FAQ,
  SUBSCRIPTION_PRICE,
} from "../constants";

export function GamesGrid() {
  return (
    <section>
      <p className="slbl">كل الألعاب</p>
      <h2 className="stitle">
        في شليل للألعاب <em>كل شيء</em> موجود
      </h2>
      <p className="ssub">
        تصفح الألعاب واختار اللي يعجبك — ما تحتاج تنزل حاجة
      </p>
      <div className="games-grid">
        {GAMES_GRID.map((g, i) => (
          <div
            key={i}
            className="game-card reveal"
            style={{ background: g.bg }}
          >
            <div className="gc-bg">{g.emoji}</div>
            <div className="gc-overlay"></div>
            <div className="gc-badge">{g.badge}</div>
            <div className="gc-info">
              <div className="gc-cat">{g.cat}</div>
              <div className="gc-name">{g.name}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export function HowTo() {
  const steps = [
    {
      n: "1",
      title: 'اضغط "اشترك الآن"',
      desc: "اضغط على أي زر اشتراك في الصفحة وبتنتقل مباشرة",
    },
    {
      n: "2",
      title: "أكد اشتراكك",
      desc: "اتبع الخطوات البسيطة على الصفحة — يأخذ ثواني بس",
    },
    {
      n: "3",
      title: "العب فوراً!",
      desc: "ادخل شليل وابدأ لعبتك الأولى من غير ما تستنى",
    },
  ];
  return (
    <section className="how-section">
      <p className="slbl">كيف تشترك</p>
      <h2 className="stitle">
        في <em>ثلاث خطوات</em> بسيطة
      </h2>
      <p className="ssub">الاشتراك سهل زي ما تتخيل — ما يأخذ دقيقتين!</p>
      <div className="how-grid">
        {steps.map((s, i) => (
          <div key={i} className="how-card reveal">
            <div className="how-n">{s.n}</div>
            <h3>{s.title}</h3>
            <p>{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export function Testimonials() {
  return (
    <section>
      <p className="slbl">آراء اللاعبين</p>
      <h2 className="stitle">
        الشباب <em>تكلم</em>
      </h2>
      <p className="ssub">
        ناس من السودان جربوا شليل للألعاب وما قدروا يوقفوا!
      </p>
      <div className="tgrid">
        {TESTIMONIALS.map((t, i) => (
          <div key={i} className="tc reveal">
            <div className="tc-stars">{"★".repeat(t.stars)}</div>
            <p className="tc-txt">{t.text}</p>
            <div className="tc-auth">
              <div className="tc-av">{t.initial}</div>
              <div>
                <div className="tc-nm">{t.name}</div>
                <div className="tc-lc">{t.city}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export function Pricing() {
  const features = [
    "أكتر من 100 لعبة متاحة فوراً",
    "بدون تحميل — العب من المتصفح",
    "يعمل على أي جهاز وأي نت",
    "ألعاب جديدة تُضاف كل فترة",
    "أكشن، رياضة، بازل، وكتير",
    "الدفع سهل ومباشر من الموبايل",
  ];
  return (
    <section className="pricing-section" id="subscribe">
      <p className="slbl">الاشتراك</p>
      <h2 className="stitle">
        سعر <em>واضح</em> ومتعة كبيرة
      </h2>
      <p className="ssub">اشتراك يومي — والعب بلا حدود طول اليوم</p>
      <div className="pcard reveal">
        <div className="pbadge">✦ الباقة اليومية</div>
        <div className="pprice">{SUBSCRIPTION_PRICE}</div>
        <div className="pperiod">جنيه / اليوم</div>
        <div className="ptax">شامل الضريبة — ألعاب بلا حدود</div>
        <ul className="pfeats">
          {features.map((f, i) => (
            <li key={i}>
              <span className="ck">✓</span> {f}
            </li>
          ))}
        </ul>
        <Link
          to="/subscribe"
          className="btn-p"
          style={{
            width: "100%",
            display: "block",
            fontSize: "1.1rem",
            padding: "1rem",
          }}
        >
          🎮 اشترك وابدأ الآن
        </Link>
        <p className="p-sub-note">
          الاشتراك يومي ويتجدد تلقائياً — تقدر توقفه في أي وقت
        </p>
      </div>
    </section>
  );
}

export function FAQSection() {
  const [open, setOpen] = useState(null);
  const toggle = (i) => setOpen(open === i ? null : i);
  return (
    <section>
      <p className="slbl">أسئلة شائعة</p>
      <h2 className="stitle">
        عندك <em>سؤال؟</em>
      </h2>
      <p className="ssub">إجابات على أكتر الأسئلة اللي بتجي في بالك</p>
      <div className="flist">
        {FAQ.map((item, i) => (
          <div key={i} className={`fi${open === i ? " open" : ""}`}>
            <div className="fq" onClick={() => toggle(i)}>
              {item.q} <span className="ficon">+</span>
            </div>
            <div className="fa">{item.a}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export function FinalCTA() {
  return (
    <div className="cta-sec">
      <h2>
        الشباب كلو في شليل للألعاب
        <br />
        <em>وأنت فين؟</em>
      </h2>
      <p>100+ لعبة بانتظارك — ابدأ من الآن وما تندم أبداً!</p>
      <Link
        to="/subscribe"
        className="btn-p"
        style={{ fontSize: "1.2rem", padding: "1rem 3rem" }}
      >
        🎮 اشترك وابدأ اللعب
      </Link>
      <p className="cta-note">
        {SUBSCRIPTION_PRICE} جنيه / اليوم شامل الضريبة · بدون تحميل · على أي
        جهاز
      </p>
    </div>
  );
}

export function Footer() {
  return (
    <footer className="footer">
      <strong>شليل للألعاب</strong> — بوابة الألعاب الإلكترونية للسودان 🎮
      <br />
      <span
        style={{ fontSize: ".75rem", marginTop: ".4rem", display: "block" }}
      >
        © 2026 شليل للألعاب. جميع الحقوق محفوظة.
      </span>
    </footer>
  );
}
